import React from 'react';
import { Row, Col, Card, Tag, Divider, Button } from 'antd';
import { useSelector } from 'react-redux';
import i18n from 'i18next';
import { intersectionBy } from 'lodash';
import PropTypes from 'prop-types';
import { formatDateTime, formatMoney } from 'utils/textUtils';
import { ORDER_STATUSES } from 'configs/localData';
import PreviewImage from 'components/common/PreviewImage';
import Icon, { ClockCircleFilled } from '@ant-design/icons';
import { ReactComponent as Deadline } from 'assets/icons/deadline.svg';
import { getOrderHistoriesSelectors } from 'redux/orders/selectors';
import HeaderSection from '../../../../components/common/HeaderSection';
import OrderInfoStyles from './styles';
import OrderStatusContent from '../OrderStatus/OrderStatusContent';

const OrderInfo = ({ order, handleToggleForm }) => {
  const niche = useSelector((state) => state.orders.niche);
  const orderFeatures = useSelector(
    (state) => state.config?.data?.orderFeature,
  );
  const products = useSelector((state) => state.config?.data?.productType);
  const statuses = useSelector((state) => state.config?.data?.orderStatus);
  const orderRequirements = useSelector(
    (state) => state.config?.data?.orderRequirement,
  );
  const platforms = useSelector((state) => state.config?.data?.platform);

  const currentProducts = intersectionBy(
    products,
    order?.productCatalogIds,
    (data) => data?.id || data,
  );
  const currentFeatures = intersectionBy(
    orderFeatures,
    order?.orderFeature,
    (data) => data?.value || data,
  );
  const orderHistories = useSelector(getOrderHistoriesSelectors);
  const orderStatus = statuses?.find((e) => e.value === order.status);
  return (
    <OrderInfoStyles
      color={orderStatus?.color}
      textColor={orderStatus?.textColor}
    >
      <Row gutter={16}>
        <Col xs={24} sm={24} lg={12} md={12}>
          <Card
            title={`#${order?.codeCustomer} `}
            extra={
              <div className="price">
                {order?.priceOrder
                  ? formatMoney(order?.priceOrder, order?.currency || 'VND')
                  : i18n.t('error.waitingUpdate')}
              </div>
            }
          >
            <Card.Meta
              avatar={<PreviewImage src={order?.thumbnail} />}
              title={
                <Row justify="space-between">
                  <Col span={12}>
                    <b>{order.name}</b>
                  </Col>
                  <Tag color="blue">
                    {
                      orderRequirements?.find(
                        (orderRequirement) =>
                          orderRequirement?.id === order?.orderRequirementId,
                      )?.name
                    }
                  </Tag>
                </Row>
              }
              description={
                <div>
                  <div className="label">
                    <ClockCircleFilled />
                    {formatDateTime(order?.createdAt)}
                  </div>
                  <div className="label deadline">
                    <Icon color="#d1d1d1" component={Deadline} />
                    {formatDateTime(order?.deadline)}
                  </div>
                </div>
              }
            />
            <br />
            {currentFeatures?.map((feature) => (
              <Tag color={feature?.color}>{` ${feature.text}`?.toString()}</Tag>
            ))}
            <br />
            <br />
            <Row justify="space-between">
              <Col span={12}>
                <HeaderSection title="orders.productCatalogIds" />
              </Col>
              <div className="value">
                {currentProducts
                  ?.map((product) => ` ${product.name}`)
                  ?.toString()}
              </div>
            </Row>
            <Divider />
            <Row justify="space-between">
              <Col span={12}>
                <HeaderSection title="orders.niche" />
              </Col>
              <div className="value">{niche?.name}</div>
            </Row>
            <Divider />
            <Row justify="space-between">
              <Col span={12}>
                <HeaderSection title="orders.platform" />
              </Col>
              <div className="value">
                {
                  platforms?.find((platform) => platform.id === order?.platform)
                    ?.name
                }
              </div>
            </Row>
            {order?.status === 'pre_order' && (
              <div className="action-row">
                <Button size="large" type="primary" onClick={handleToggleForm}>
                  {i18n.t('button.edit')}
                </Button>
              </div>
            )}
          </Card>
        </Col>
        <br />
        <Col xs={24} sm={24} lg={12} md={12}>
          <Card
            extra={
              <Tag
                color={
                  ORDER_STATUSES?.find(
                    (status) => status.value === order.status,
                  )?.color
                }
              >
                {orderStatus?.text}
              </Tag>
            }
            title="Order Process"
          >
            <OrderStatusContent
              onCancel={() => {}}
              orderStatus={
                orderHistories?.[orderHistories?.length - 1 || 0] || {}
              }
              order={order}
            />
          </Card>
        </Col>
        <br />
        <Col xs={24} sm={24} lg={24} md={24}>
          <Card title={i18n.t('orders.customerRequirements')}>
            <div
              className="customer-requirements"
              dangerouslySetInnerHTML={{ __html: order?.customerRequirements }}
            />
          </Card>
        </Col>
      </Row>
    </OrderInfoStyles>
  );
};

OrderInfo.propTypes = {
  order: PropTypes.object,
  handleToggleForm: PropTypes.func,
};

export default OrderInfo;
